import React from 'react';
import { Dismiss20Regular } from '@fluentui/react-icons';
import styles from '../css/vdr.module.css';

const DeleteFolderConfirmModal = ({ open, onClose, onConfirm, folderName = '', loading }) => {
    const [step, setStep] = React.useState(1);

    React.useEffect(() => {
        if (open) setStep(1);
    }, [open]);

    if (!open) return null;

    const title = step === 1 ? `Delete folder${folderName ? `: ${folderName}` : ''}?` : 'Confirm deletion';

    return (
        <div className={styles.overlay} role="dialog" aria-modal="true">
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>{title}</h2>
                    <button type="button" className={styles.iconBtn} onClick={onClose} aria-label="Close">
                        <Dismiss20Regular />
                    </button>
                </div>
                <div className={styles.modalBody}>
                    {step === 1 ? (
                        <>
                            <p className={styles.deleteWarnText}>
                                Deleting this folder will also delete all files and subfolders inside it. This cannot be undone.
                            </p>
                            <p className={styles.deleteHelperText}>Continue to review the final confirmation.</p>
                        </>
                    ) : (
                        <p className={styles.deleteWarnText}>
                            This action cannot be undone. Permanently delete
                            {folderName ? <> &quot;{folderName}&quot;</> : ' this folder'} and everything in it?
                        </p>
                    )}
                </div>
                <div className={styles.modalFooter}>
                    {step === 1 ? (
                        <button type="button" className={styles.primaryBtn} onClick={() => setStep(2)}>
                            Continue
                        </button>
                    ) : (
                        <button type="button" className={styles.primaryBtn} style={{ background: '#dc2626' }} onClick={onConfirm} disabled={loading}>
                            Delete folder
                        </button>
                    )}
                    <button type="button" className={styles.secondaryBtn} onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteFolderConfirmModal;
